import { CONTENT_TYPES_WITH_FILTER_PREFIX } from "./algoliaFilters";

export const ECARDS = Object.freeze({
  label: "Ecards",
  key: "ecards",
  value: [
    CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouEcard,
    CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouVertical,
    CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouClip,
  ],
});

export const AI_IMAGE_PACKS = Object.freeze({
  label: "AI Image Packs",
  key: "aiImagePacks",
  value: [CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouAI],
});

export const QUICK_SENDS = Object.freeze({
  label: "Quick Sends",
  key: "quicksends",
  value: [CONTENT_TYPES_WITH_FILTER_PREFIX.straightUpEcard],
});

export const INVITES = Object.freeze({
  label: "Invites",
  key: "invites",
  value: [CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouInvite, CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouInviteGif],
});

export const ALL_CONTENT_TYPES = [ECARDS, AI_IMAGE_PACKS, QUICK_SENDS, INVITES];

export const createAllOption = (contentTypes) => ({
  label: "All",
  key: "all",
  value: contentTypes.flatMap((item) => item.value),
});
